exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".public__body,.public__header{border-bottom-width:1px;border-bottom-style:solid;border-bottom-color:#ddd}.public__header{display:flex;justify-content:space-between;align-items:center;padding-bottom:.35rem}.public__header h1{color:#0087f8;margin:0;font-size:1rem}.public__header span{font-size:.85rem}.public__body{word-wrap:break-word;white-space:pre-wrap;height:18rem;overflow-y:scroll;color:#000;font-size:.95rem;font-family:Avenir,Lato,sans-serif;padding-top:.75rem;padding-bottom:.75rem;margin-bottom:.5rem}.public__footer{text-align:center;font-weight:500;font-size:.9rem}.public__footer a{color:#0087f8;transition:color .25s ease-in-out}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-d36cd75c!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/app/Public.vue
// module id = 945
// module chunks = 0